import { render, staticRenderFns } from "./addMedia.vue?vue&type=template&id=c67f8346&scoped=true&"
import script from "./addMedia.vue?vue&type=script&lang=js&"
export * from "./addMedia.vue?vue&type=script&lang=js&"
import style0 from "./addMedia.vue?vue&type=style&index=0&id=c67f8346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67f8346",
  null
  
)

export default component.exports